import { render, staticRenderFns } from "./sku-card-children.vue?vue&type=template&id=c2fc7d4a&"
import script from "./sku-card-children.vue?vue&type=script&lang=js&"
export * from "./sku-card-children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports